import render from "common/render-component";

import ClientLandingApp from "../client-landing/client-landing-app";

render(ClientLandingApp, "#client-landing");
